/* eslint-disable max-len */
/* eslint-disable new-cap */
import { jsPDF } from 'jspdf';
import moment from 'moment';
import logo from '../../../shared/img/logo/logo.png';
import groupServices from '../../../redux/services/groupServices';
import companyServices from '../../../redux/services/companyServices';
import { doesSemesterExists } from '../../../helpers/utils';

const addText = (doc, x, y, object) => {
  if (object) {
    doc.text(x, y, object.toString());
  } else {
    doc.text(x, y, '/');
  }
};

const getGap = (date1, date2) => {
  const dateDiff = date2 - date1;
  const diffMins = Math.round(dateDiff / 60 / 1000); // minutes
  let hoursDiff = Math.round((diffMins - (diffMins % 60)) / 60);
  const daysDiff = (hoursDiff - (hoursDiff % 24)) / 24;
  hoursDiff %= 24;
  return `${daysDiff > 0 ? `${Math.round(daysDiff)}j ` : ''
  }${hoursDiff >= 1 || diffMins % 60 >= 1 ? `${hoursDiff}h ` : ''}${diffMins % 60 < 10 && diffMins % 60 > 0 ? '0' : ''}${diffMins % 60 > 0 ? `${diffMins % 60}min` : ''
  }`;
};

const exportPdf = (adminData, pedagogicData, semesters, tableData, tableData2) => {
  const doc = new jsPDF();
  let gap = 140;
  let gap2 = 0;
  const imgPDF = new Image();
  imgPDF.src = logo;

  doc.setDrawColor(63, 81, 181);
  doc.setFillColor(63, 81, 181);
  doc.addImage(imgPDF, 'png', 165, 35, 30, 20);
  doc.setFontSize(20);
  doc.rect(5, 12, 200, 10, 'F');
  doc.setTextColor(255, 255, 255);
  doc.text(10, 20, 'Administratif');
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.text(10, 30, 'Nom de l\'école:');
  addText(doc, 36, 30, adminData ? adminData.denomination : null);
  doc.text(10, 37, 'Type de l\'école:');
  addText(doc, 36, 37, adminData ? adminData.type : null);
  doc.text(10, 44, 'Adresse de l\'établissement:');
  addText(doc, 55, 44, adminData ? adminData.address : null);
  doc.text(10, 51, 'Numéro de téléphone:');
  addText(doc, 47, 51, adminData ? adminData.phone : null);
  doc.text(10, 58, 'Numéro de SIRET:');
  addText(doc, 42, 58, adminData ? adminData.siret : null);

  doc.setFontSize(20);
  doc.setDrawColor(63, 81, 181);
  doc.setFillColor(63, 81, 181);
  doc.rect(5, 67, 200, 10, 'F');
  doc.setTextColor(255, 255, 255);
  doc.text(10, 75, 'Contact de facturation');
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.text(10, 85, 'Nom:');
  addText(doc, 20, 85, adminData ? adminData.billingContact.firstname : null);
  doc.text(10, 92, 'Prénom:');
  addText(doc, 25, 92, adminData ? adminData.billingContact.name : null);
  doc.text(10, 99, 'Téléphone:');
  addText(doc, 30, 99, adminData ? adminData.billingContact.phone : null);
  doc.text(10, 106, 'Email:');
  addText(doc, 22, 106, adminData ? adminData.billingContact.email : null);

  doc.setFontSize(20);
  doc.setDrawColor(63, 81, 181);
  doc.setFillColor(63, 81, 181);
  doc.rect(5, 113, 200, 10, 'F');
  doc.setTextColor(255, 255, 255);
  doc.text(10, 121, 'Contact financier');
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.text(10, 131, 'Nom:');
  addText(doc, 20, 131, adminData && adminData.financialContact ? adminData.financialContact.firstname : null);
  doc.text(10, 138, 'Prénom:');
  addText(doc, 25, 138, adminData && adminData.financialContact ? adminData.financialContact.name : null);
  doc.text(10, 145, 'Téléphone:');
  addText(doc, 30, 145, adminData && adminData.financialContact ? adminData.financialContact.phone : null);
  doc.text(10, 152, 'Email:');
  addText(doc, 22, 152, adminData && adminData.financialContact ? adminData.financialContact.email : null);

  doc.setFontSize(17);
  doc.setDrawColor(63, 81, 181);
  doc.setFillColor(63, 81, 181);
  doc.rect(5, 159, 200, 10, 'F');
  doc.setTextColor(255, 255, 255);
  doc.text(10, 167, 'Liste des référents');
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  gap += 46;
  if (pedagogicData.length > 0) {
    doc.text(10, 177, 'Nom');
    doc.text(50, 177, 'Prénom');
    doc.text(90, 177, 'Email');
    doc.text(150, 177, 'Téléphone');
    pedagogicData.forEach((index) => {
      addText(doc, 10, gap, index.firstname);
      addText(doc, 50, gap, index.name);
      doc.text(90, gap, index.email);
      addText(doc, 150, gap, index.phone);
      gap += 10;
    });
  } else {
    doc.text(10, 179, 'Pas de référent');
  }
  gap = 40;
  doc.addPage();
  doc.setFontSize(17);
  doc.setDrawColor(63, 81, 181);
  doc.setFillColor(63, 81, 181);
  doc.rect(5, 13, 200, 10, 'F');
  doc.setTextColor(255, 255, 255);
  doc.text(10, 20, 'Liste des semestres');
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  if (semesters.length > 0) {
    doc.text(10, 30, 'Semestre');
    doc.text(35, 30, 'H d\'e-learning');
    doc.text(67, 30, 'Grp présentiels');
    doc.text(97, 30, 'H présentiels');
    doc.text(125, 30, 'Début/Fin/Ratt.');
    doc.text(150, 30, 'Formateur EW');
    doc.text(180, 30, 'Référents');
    semesters.forEach((index) => {
      addText(doc, 10, gap, index.semester);
      addText(doc, 35, gap, `${(((index.elearningHours / 60) * 10) - (((index.elearningHours / 60) * 10) % 10)) / 10}h${index.elearningHours % 60 <= 9 ? '0' : ''}${index.elearningHours % 60}`);
      if (index.presentialGroups === null) {
        doc.text(67, gap, '/');
      } else {
        doc.text(67, gap, index.presentialGroups.toString());
      }
      if (index.presentialHours === null) {
        doc.text(97, gap, '/');
      } else {
        doc.text(97, gap, `${((index.presentialHours / 60) * 10 - (((index.presentialHours / 60) * 10) % 10)) / 10}h${index.presentialHours % 60 <= 9 ? '0' : ''}${index.presentialHours % 60}`);
      }
      const formatedDate = moment(index.beginDate).format('DD/MM/YYYY');
      doc.text(125, gap, formatedDate.toString());
      const formatedDate2 = moment(index.endDate).format('DD/MM/YYYY');
      doc.text(125, gap + 5, formatedDate2.toString());
      let formatedDateCatchUp = 'Pas de date';
      if (index.catchUpDate) {
        formatedDateCatchUp = moment(index.catchUpDate).format('DD/MM/YYYY');
      }
      doc.text(125, gap + 10, formatedDateCatchUp.toString());
      if (index.needFormer === true) {
        doc.text(150, gap, 'Oui');
      } else {
        doc.text(150, gap, 'Non');
      }
      gap2 = gap;
      index.referents.forEach((index2) => {
        doc.text(180, gap2, index2.firstname.toString());
        gap2 += 5;
      });
      gap = gap2 + 15;
    });
  } else {
    doc.text(10, 30, 'Pas de semestre');
  }
  gap += 10;
  doc.setFontSize(17);
  doc.setDrawColor(63, 81, 181);
  doc.setFillColor(63, 81, 181);
  doc.rect(5, gap - 7, 200, 10, 'F');
  doc.setTextColor(255, 255, 255);
  doc.text(10, gap, 'Liste des examens');
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  if (tableData.length > 0) {
    gap += 10;
    doc.text(10, gap, 'Examen');
    doc.text(50, gap, 'Semestre');
    doc.text(75, gap, 'Modalité');
    doc.text(112, gap, 'Début et durée');
    doc.text(150, gap, 'EW corrigé');
    doc.text(185, gap, 'Rattrapage');
    gap += 10;
    tableData.forEach((index) => {
      addText(doc, 10, gap, index.examSubject ? index.examSubject.name : '/');
      addText(doc, 50, gap, index.semester);
      addText(doc, 75, gap, index.modality);
      const formatedDate3 = moment(index.examBegin).format('DD/MM - HH:mm');
      doc.text(112, gap, formatedDate3.toString());
      const tmp = getGap(moment(index.examBegin), moment(index.examEnd));
      doc.text(112, gap + 5, tmp);
      if (index.EWcorrect === true) {
        doc.text(150, gap, 'Oui');
      } else {
        doc.text(150, gap, 'Non');
      }
      if (index.catchUp === true) {
        doc.text(185, gap, 'Oui');
      } else {
        doc.text(185, gap, 'Non');
      }
      gap += 10;
    });
  } else {
    gap += 10;
    doc.text(10, gap, 'Pas d\'examen');
    gap += 10;
  }
  gap += 10;
  doc.setFontSize(17);
  doc.setDrawColor(63, 81, 181);
  doc.setFillColor(63, 81, 181);
  doc.rect(5, gap - 7, 200, 10, 'F');
  doc.setTextColor(255, 255, 255);
  doc.text(10, gap, 'Liste des critères par semestres');
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  if (tableData2.length > 0) {
    gap += 10;
    doc.text(10, gap, 'Semestre');
    doc.text(50, gap, '% Quiz');
    doc.text(95, gap, '% Programme');
    doc.text(142, gap, 'Temps de connexion');
    gap += 10;
    tableData2.forEach((index) => {
      addText(doc, 10, gap, index.semester);
      if (!index.quizPercent || index.quizPercent === 0) {
        doc.text(50, gap, 'Pas concerné');
      } else {
        doc.text(50, gap, `${index.quizPercent.toString()}%`);
      }
      if (!index.unitsPercent || index.unitsPercent === 0) {
        doc.text(95, gap, 'Pas concerné');
      } else {
        doc.text(95, gap, `${index.unitsPercent.toString()}%`);
      }
      if (!index.connexionTime || index.connexionTime === 0) {
        doc.text(142, gap, 'Pas concerné');
      } else {
        doc.text(142, gap, `${index.connexionTime.toString()}% de ${(((index.elearningDuration / 60) * 10) - (((index.elearningDuration / 60) * 10) % 10)) / 10}h${index.elearningDuration % 60 <= 9 ? '0' : ''}${index.elearningDuration % 60}`);
      }
      gap += 10;
    });
  } else {
    gap += 10;
    doc.text(10, gap, 'Pas de critères');
  }
  doc.save('export_data.pdf');
};

const exportCompanyData = (companyId) => {
  companyServices.getCompanyDataById(companyId)
    .then((companyData) => {
      groupServices.getGroupsDataByCompagny(companyId)
        .then((groups) => {
          const examsData = [];
          if (groups.data) {
            const groupsArr = Object.values(groups.data);
            groupsArr.forEach((group) => {
              if (group.elearning
            && group.elearning.elearningOptions
            && group.elearning.elearningOptions.length > 0
            && group.level === 1) {
                group.elearning.elearningOptions.forEach((option) => {
                  examsData.push({ ...option, semester: group.semester });
                });
              }
            });
          }
          const criteriasData = [];
          for (let i = 0; groups.data[i]; i += 1) {
            if (doesSemesterExists({ value: groups.data[i].semester }, criteriasData) === false) {
              criteriasData.push({
                semester: groups.data[i].semester,
                quizPercent: groups.data[i].elearning.elearningTarget,
                unitsPercent: groups.data[i].elearning.elearningAttempts,
                connexionTime: groups.data[i].elearning.elearningDurationTarget,
                elearningDuration: groups.data[i].elearning.elearningDuration,
              });
            }
          }
          criteriasData.sort((a, b) => a.semester - b.semester);
          exportPdf(companyData.adminData, companyData.pedagogicData, companyData.semesters, examsData, criteriasData);
        });
    });
};

export default exportCompanyData;
